// Static
import menuList from '@/app/static/json/nav-menu-links.json';

// Components
const SwitchPet = () => import(/* webpackPrefetch: true, webpackChunkName: 'switch-pet' */ '@/app/views/main-view/_shared/_components/switch-pet/switch-pet.vue');
const FileUpload = () => import(/* webpackPrefetch: true, webpackChunkName: "file-upload" */ '@/app/views/main-view/_shared/_components/file-upload/file-upload.vue');
		
// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { comingSoonMixins } from '@/app/mixins/utils/coming-soon-mixins';
import { trackingSubscriptionMixins } from '@/app/mixins/modules/tracking-subscription-mixins';
import { imageCompressorMixins } from '@/app/mixins/utils/image-compressor-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';

// Services
import PetsService from '@/app/services/main/pets/pets-service';

import EventBus from '@/app/bus/event-bus';

export default {
	name: 'Sidebar',
	components: {
		SwitchPet,
		FileUpload
    },
    mixins: [
		userMixins,
	    comingSoonMixins,
	    trackingSubscriptionMixins,
	    imageCompressorMixins,
	    dateMixins
	],
	data() {
		return {
			menuList: menuList,
			displaySideBar: false,
			fadeSideBar: false,

			imageToCrop: '',
			fileBlob: null,
			isImageChanged: false,
		}
	},
	computed: {
		showSideBar() {
			this.animateSideBar();
			return this.$store.getters.getSideBar;
		},
		overdueTreatmentCount() {
			return this.$store.getters.getOverdueTreatmentCount;
		},
		groupAdminRequests() {
			return this.$store.getters.getGroupAdminRequests;
		}
	},
	async created() {
		await this.$store.dispatch('setTreatmentOverdueCount');
		await this.$store.dispatch('setGroupAdminRequest');
	},
	methods: {
		animateSideBar() {
			const sidebar = this.$store.getters.getSideBar;
			let timeout = sidebar ? 50 : 250;
			
			if (sidebar) {
				this.displaySideBar = sidebar;
				setTimeout(() => {
					this.fadeSideBar = sidebar;
				}, timeout);
			} else {
				this.fadeSideBar = sidebar;
				setTimeout(() => {
					this.displaySideBar = sidebar;
				}, timeout);
			}
		},
		getIcon(icon) {
			return require(`@/assets/images/_shared/${icon}`);
		},
		toggleSideBar() {
			this.$store.commit('toggleSideBar');
			this.animateSideBar();
		},
		closeSideBarOnNavigate() {
			this.$store.commit('closeSideBar');
			this.animateSideBar();
		},
		async navigateToPath(url) {
			if (this.$route.path !== url) {
				this.$router.push(url,  () => {});
			}

			this.closeSideBarOnNavigate();
		},
		addAnotherPet() {
			this.$emit('addAnotherPet');
		},
		async onSidebarUploadImage(event) {
			let valid = await this.validateImage(event.target.files[0]);

			// compress image if more than 2mb
			const file = await this.compressImage(event.target.files[0]);

			// do nothing when user cancels Upload
			if(!valid) {
				// reset uploader
				this.$refs.uploader.value = '';
				return;
			}

			this.isImageChanged = true;
			this.fileBlob = [file];

			// show preview of pet image
			let reader = new FileReader();
			reader.onload = () => {
				this.imageToCrop = reader.result;
				this.$refs.modalSidebarFileUpload.show();
			}

			reader.readAsDataURL(file);
		},
		setImageCrop({image, blob}) {
			this.fileBlob = blob;
			let petDetails = {
				formData: {
					name: this.getActivePet.name,
					birthdate: this.getActivePet.birthdate,
					isImageChanged: this.isImageChanged
				},
				profileImage: this.fileBlob ? this.fileBlob[0] : ''
			}
            PetsService.putPetById(this.getActivePet.id, petDetails)
            .then(async res => {
                if(res.status === 204){
                    this.showCustomSuccessToast(null, 'Successfully Updated Photo!');
					this.getUserDetailsAPI(true, this.getActivePet.id);

					//reset data
					this.fileBlob = null;
					this.isImageChanged = false;
					this.imageToCrop = '';
					EventBus.$emit('petSwitched');
                }else{
                    this.showCustomErrorToast(null, "Something went wrong. Please contact your administrator.");
                }
            });
		},
		clearSidebarFileInput(event) {
			event.target.value = '';
		}
	}
};
